import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Address from "./Address";
import PaymentSuccess from "./Paymentsuccess";
import PaymentFailed from "./PaymentFailed";
import axios from "axios";
import { toast } from "react-toastify";
import PhonePayLogoImg from '../Components/img/PhonePe-Logo.png'
import GPayLogoImg from '../Components/img/Google_Pay-Logo.png'
import VisaLogoImg from '../Components/img/Visa_Inc.-Logo.png'
import MasterLogoImg from '../Components/img/Mastercard-Logo.png'
import RupayLogoImg from '../Components/img/Rupay-Logo.png'
import PaytmLogoImg from '../Components/img/Paytm-Logo.png'
import img1 from "./img/100BILLION_ICON.png"

const Checkout = () => {
    const [isEditingContact, setIsEditingContact] = useState(false);
    const [email, setEmail] = useState("dummyemail@example.com");
    const [mobile, setMobile] = useState("9876543210");
    const [gst, setGst] = useState("22AAAAA0000A1Z5");
    const [showOptions, setShowOptions] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState("Pay now");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [cart, setCart] = useState([])
    const [total, setTotal] = useState(0)
    const navigate = useNavigate();
    const login = JSON.parse(localStorage.getItem("login")) || false;
    const [data, setData] = useState({
        location_user: "",
        new_address: "",
        city: "",
        pincode: "",
        user_id: login.emplyee_ID,
        user_name: login.full_name,
    })


    const [userDetails, setUserDetails] = useState({
        email: login?.email || "",
        phone: login?.phone || "",
        gst: login?.gst || "",
    });
    const [gstData, setGstData] = useState([])
    const duration = sessionStorage.getItem("cart_duration") || "3y";
    const [phoneError, setPhoneError] = useState("");



    console.log(data)
    const fetchCartData = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/cart/getcartadded/${login.emplyee_ID}`)
            const data = await response.json();
            // const activeItems = data.filter(item => item.status === "Active");
            const total = data.reduce((acc, item) => acc + Number(item.product_price), 0);
            console.log(total);
            setTotal(total);
            setCart(data)
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    const toggleOptions = () => {
        setShowOptions(!showOptions);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    const selectPayment = (option) => {
        setSelectedPayment(option);
        setShowOptions(false); // Close options after selection
    };
    console.log(userDetails)
    const handleSaveContact = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/user-register/api/google-update/${login.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userDetails.email,
                    phone: userDetails.phone,
                    gst: userDetails.gst,
                })
            });

            const res = await response.json(); // Await here too

            if (response.ok) {
                console.log(res.message || "Updated successfully");
                setIsEditingContact(false);
                localStorage.setItem("login", JSON.stringify({
                    ...login,
                    phone: userDetails.phone,
                    gst: userDetails.gst,
                }));
                setPhoneError("")
                fetchCartData();
            } else {
                console.error(res.message || "Failed to update contact details");
            }

        } catch (error) {
            console.error("Error while updating contact details:", error);
        }
    };



    const getMultiplier = () => {
        switch (duration) {
            case "1y": return (12);
            case "3y": return (36 * 70 / 100);
            default: return 1;
        }
    };

    const gstPercentage = gstData.length > 0 ? Number(gstData[0].price) : 0;
    const subtotal = cart.reduce((acc, p) => acc + Number(p.product_price) * getMultiplier(), 0);
    const gstAmount = (subtotal * gstPercentage) / 100;
    const totalPrice = subtotal + gstAmount;


    const fetchPincodes = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/gst`);
            const res = await response.json();
            setGstData(res.data || []);
            console.log(res);
        } catch (error) {
            console.log(error);
        }
    };

    const handleClick = async () => {
        // Address Validation
        // if (!data.new_address || !data.city || !data.pincode) {
        //     toast.error("Please add an address first.", {
        //         position: "top-center",
        //         autoClose: 2000
        //     });
        //     return;
        // }

        if (!userDetails.phone || userDetails.phone.trim().length < 10) {
            setPhoneError("Mobile number is required");
            toast.error("Please add a valid mobile number first.", {
                position: "top-center",
                autoClose: 2000
            });
            return;
        }


        let orderId = "11" + Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
        let paymentDetails = {
            user_id: login.emplyee_ID,
            user_phone: login.full_name,
            transaction_id: orderId,
            amount: totalPrice * 100,
            currency: "INR",
            payment_mode: "Online",
            item: cart,
            phone: userDetails.phone,
            user_email: userDetails.email,
            gst: userDetails.gst,
            duration:duration ||"3y",
        };
        console.log(paymentDetails);
        setPhoneError("")
        localStorage.setItem("payment", JSON.stringify(paymentDetails));

        try {
            let response = await axios.post('https://100billionrealestate.com/payment-pay/create-order', paymentDetails);
            const { checkoutPageUrl } = response.data;

            if (checkoutPageUrl) {
                window.location.href = checkoutPageUrl;
            }
        } catch (error) {
            toast.error("Error initiating payment. Please try again.", {
                position: "top-center",
                autoClose: 2000
            });
            console.error('Error initiating payment:', error);
        }
    };

    useEffect(() => {
        fetchPincodes();
    }, [])
    useEffect(() => {
        fetchCartData();
    }, [])

    return (
        <>
            <div className="checkout-perfume">
                <div className="cart-columns-perfume">
                    <div className="address-container cart-column1-perfume">
                        <Address data={data} setData={setData} />
                        <div className="contact-info">
                            <h3>Contact Information</h3>

                            {isEditingContact ? (
                                <div className="contact-edit">
                                    <div className="contact-edit-input">
                                        <input
                                            type="email"
                                            name="email"
                                            value={userDetails.email}
                                            onChange={handleChange}
                                            placeholder="Enter email"
                                            disabled
                                        />
                                        <input
                                            type="text"
                                            name="phone"
                                            value={userDetails.phone}
                                            onChange={handleChange}
                                            placeholder="Enter mobile number"
                                        />
                                        <input
                                            type="text"
                                            name="gst"
                                            value={userDetails.gst}
                                            onChange={handleChange}
                                            placeholder="Enter GST number"
                                        />
                                    </div>
                                    <button onClick={handleSaveContact}>Save</button>
                                </div>
                            ) : (
                                <p className="contact-details">
                                    <div><strong>Email:</strong> {userDetails.email}</div>
                                    <div><strong>Mobile:</strong> {userDetails.phone || "N/A"}</div>
                                    {phoneError && (
                                        <p style={{ color: 'red', fontSize: '0.9rem', marginTop: '4px',fontWeight: '500' }}>
                                            *{phoneError}
                                        </p>
                                    )}
                                    <div><strong>GST:</strong> {userDetails.gst || "N/A"}</div>
                                </p>
                            )}

                            {!isEditingContact && (
                                <button onClick={() => setIsEditingContact(true)} className="edit-contact-button">
                                    Change
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="cart-column2-perfume">
                        <div className="cart-column2-header-perfume">
                            <h3>Order Summary</h3>
                            <button
                                className="checkout-edit-order-hbt"
                                onClick={() => navigate("/cart")}
                            >
                                Edit Orders
                            </button>
                        </div>
                        <div className="cart-column2-total-perfume">
                            <div className="cart-total-labels">
                                <p><strong>Sub total</strong></p>
                                <p><strong>Gst ({gstPercentage}%)</strong></p>
                                <h3>Total Price</h3>
                            </div>
                            <div className="cart-total-value">
                                <p><strong>₹{Math.round(cart.reduce((acc, p) => acc + Number(p.product_price) * getMultiplier(), 0)).toLocaleString("en-IN")}</strong></p>
                                <p><strong>₹{Math.round(gstAmount).toLocaleString("en-IN")} </strong></p>
                                <h3>₹{Math.round(totalPrice).toLocaleString("en-IN")}</h3>
                            </div>
                        </div>
                        <div className="card-saved-value">
                            <img src={img1} alt="" className='card-saved-logo' />
                            <p>Nice! you saved ₹{Math.round(cart.reduce((acc, p) => acc + Number(p.product_ogprice) * getMultiplier(), 0) - cart.reduce((acc, p) => acc + Number(p.product_price) * getMultiplier(), 0)).toLocaleString("en-IN")} On your order</p>
                        </div>

                        <div className="checkout-payment-container">
                            <div className="payment-text" onClick={toggleOptions}>
                                <div>Pay using</div>
                                <div><img src={PhonePayLogoImg} alt="" /></div>
                            </div>

                            <button className="payment-button"
                                // onClick={() => setShowSuccessModal(true)}
                                onClick={handleClick}
                            >Place order</button>
                        </div>

                        <div className="checkout-secure-conatiner">
                            <div className="checkout-secure-text">
                                <p>Secure payment with</p>
                            </div>
                            <div className="checkout-secure-img">
                                <img src={PhonePayLogoImg} alt="" />
                                <img src={GPayLogoImg} alt="" />
                                <img src={VisaLogoImg} alt="" />
                                <img src={MasterLogoImg} alt="" />
                                <img src={RupayLogoImg} alt="" />
                                <img src={PaytmLogoImg} alt="" />
                            </div>
                            <div className="checkout-terms-p">
                                <p>By clicking "Place order", You agree to our <Link to='/terms-and-conditions'>Terms & conditions</Link> and <Link to="/privacy-policy">Privacy policy</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* {showSuccessModal && <PaymentSuccess onClose={() => setShowSuccessModal(false)} />} */}
        </>
    );
};

export default Checkout;
